<template>
    <div class="list-item">
        <div
            class="list-item__header "
            @click="toggleItem()"
        >
            <span class="material-icons">
                {{isOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}
            </span>

            <span class="label ellipsis">
                {{headerLabel}}
            </span>

            <or-icon-button
                v-show="$props.isDeletable"
                class="flat"
                icon="delete"
                size="small"
                type="secondary"
                @click.stop="deleteItem"
            />
        </div>

        <div
            v-if="isOpen"
            class="list-item__body"
        >
            <or-textbox
                v-model="localCanonicalForm"
                :label="$t('model.nlu-model.sidebar.entities.editors.list-entity.listitem.canonicalForm.label')"
                :placeholder="$t('model.nlu-model.sidebar.entities.editors.list-entity.listitem.canonicalForm.placeholder')"
                :invalid="errors && errors.canonicalForm && !isLoading"
                :error="errors && errors.canonicalForm"
            />

            <or-chips
                v-model="localList"
                :label="$t('model.nlu-model.sidebar.entities.editors.list-entity.listitem.synonyms.label')"
                :simpleText="true"
                :helpText="$t('model.nlu-model.sidebar.entities.editors.list-entity.listitem.synonyms.helpText')"
            />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    canonicalForm: String,
    list: Array,
    isDeletable: Boolean,
    isLoading: Boolean,
    errors: Object,
    usedNames: Array // Used for validation
  },

  computed: {
    headerLabel () {
      return this.$props.canonicalForm || this.$t('generic.list')
    },

    localList: {
      get () {
        return this.$props.list
      },
      set (value) {
        this.$emit('update:list', value)
      }
    },

    localCanonicalForm: {
      get () {
        return this.$props.canonicalForm
      },
      set (value) {
        this.$emit('update:canonical-form', value)
      }
    }
  },

  data () {
    return {
      localItem: Object,
      isOpen: true
    }
  },

  methods: {
    toggleItem () {
      this.isOpen = !this.isOpen
    },

    deleteItem () {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .list-item {
      display: flex;
      flex-direction: column;

      &__header {
          display: flex;
          align-items: center;

          &:hover {
              cursor: pointer;
          }

          .material-icons {
              font-size: 18px;
              margin-right: $sp-2;
          }

          .label {
              color: rgb(30, 35, 43);
              font-size: 14px;
              font-weight: 600;
              height: 16px;
              width: 311px;
          }
      }

      &__body {

      }
  }
</style>
